export const TRANSACTION_TYPES = {
  capture: "Funds Captured",
  refund: "Refund Initiated",
};

export const CARD_TYPES = {
  PHYSICAL: "physical",
  VIRTUAL: "virtual",
};
